import React, { FC } from 'react'
import css from './Insta.module.scss'
import cx from 'classnames'
import Image from '../../../common/Image/Image'
import { IIGData } from '../../../types'

const Insta: FC<{ instagram: IIGData[] }> = ({ instagram }) => {
  if (!instagram) {
    return null
  }

  return (
    <section className={css.wrapper}>
      <h3 className={css.title}>Наш Instagram #kristallminerals</h3>
      <ul className={css.photos}>
        {instagram.map((item, index) => (
          <li key={item.code} className={cx(index === 0 && css.big, css.photo)}>
            <a href={item.link} target="_blank" rel="noreferrer">
              <Image src={item.photo} alt="Instagram" layout="fill" />
            </a>
          </li>
        ))}
      </ul>
    </section>
  )
}

export default Insta
